
export const BRAND_NAME = 'kanzler';